import { VehicleValuationProvider } from "@/api-schema-enums";
import { EmptyValue } from "@/components/ui/empty-value";
import { VEHICLE_VALUATION_PROVIDER_TRANSLATIONS } from "@/components/vehicle-valuation/vehicle-valuation-provider-translations";
import { useTranslation } from "react-i18next";
import { Badge, BadgeColorVariant, BadgeVariant } from "../ui/badge";

interface VehicleValuationProviderBadgeProps {
  provider?: VehicleValuationProvider | null;
}

export const VehicleValuationProviderBadge = ({ provider }: VehicleValuationProviderBadgeProps) => {
  const { t } = useTranslation("fab");

  if (!provider) {
    return <EmptyValue />;
  }

  return (
    <Badge variant={BadgeVariant.Outlined} colorVariant={BadgeColorVariant.Secondary}>
      {t(VEHICLE_VALUATION_PROVIDER_TRANSLATIONS[provider])}
    </Badge>
  );
};
